import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import withFormGroup from "../../../modules/commons/withFormGroup";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleTextArea from "../../../modules/simpleTextArea";
import Api from "../../../Services/Api";
import { ACTIVITY_TYPE } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";

class MasterLeasingModifying extends Component {
  constructor(props) {
    super(props);
    this.state = {
      provinceOptions: [],
      kotaOptions: [],
      kecamatanOptions: [],
      kelurahanOptions: [],
      cabangOptions: [],
      groupLeasingOptions: []
    };
  }

  async componentDidMount() {
    const responses = await Promise.all([
      Api.create("NAGAMAS_MASTER_DATA").getAllProvince(),
      Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang(),
      Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
        paramFilters: {
          bizparCategory: "LEASING_GROUP",
          status: "ACTIVE",
        },
      }),
    ]);

    if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        provinceOptions: responses[0].data.data.map((option) =>
          mapToObjectDDL(option.provinceName, option.id)
        ),
      }));
    }

    if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        cabangOptions: responses[1].data.data.map((c) =>
          mapToObjectDDL(c.namaDealer, c.kodeCabang)
        ),
      }));
    }
    
    if (responses[2].ok && !R.isEmpty(responses[2].data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        groupLeasingOptions: responses[2].data.data.map((c) =>
          mapToObjectDDL(c.value, c.key)
        ),
      }));
    }

    if (R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
      const controls = this.props.controls;
      if (!R.isNil(controls.provinceId.value)) {
        this.fetchKotaOptions(controls.provinceId.value.value);
      }

      if (!R.isNil(controls.kabkotId.value)) {
        this.fetchKecamatanOptions(controls.kabkotId.value.value);
      }

      if (!R.isNil(controls.kecamatanId.value)) {
        this.fetchKelurahanOptions(controls.kecamatanId.value.value);
      }
    }
  }

  fetchKotaOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(id);
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kotaOptions: response.data.data.map((option) =>
          mapToObjectDDL(option.kabKotName, option.kabKotId)
        ),
      }));
    }
  };

  fetchKecamatanOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(id);
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kecamatanOptions: response.data.data.map((option) =>
          mapToObjectDDL(option.kecamatanName, option.id)
        ),
      }));
    }
  };

  fetchKelurahanOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(id);
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kelurahanOptions: response.data.data.map((option) => ({
          ...mapToObjectDDL(`${option.zipcode} - ${option.kelurahanname}`, option.zipcode),
          kelurahanId: option.id,
        })),
      }));
    }
  };

  handleChangeProvince = async (name, value) => {
    this.props.setValue("kabkotId", null);
    this.props.setValue("kecamatanId", null);
    this.props.setValue("zipCode", null);
    this.props.setValue(name, value);
    if (!R.isNil(value)) {
      this.fetchKotaOptions(value.value);
    }
  };

  handleChangeKota = async (name, value) => {
    this.props.setValue("kecamatanId", null);
    this.props.setValue("zipCode", null);
    this.props.setValue(name, value);
    if (!R.isNil(value)) {
      this.fetchKecamatanOptions(value.value);
    }
  };

  handleChangeKecamatan = async (name, value) => {
    this.props.setValue("zipCode", null);
    this.props.setValue(name, value);
    if (!R.isNil(value)) {
      this.fetchKelurahanOptions(value.value);
    }
  };

  handleValueChange = (name, value) => {
    this.props.setValue(name, value);
  };

  handleTextChange = ({ target }) => {
    this.handleValueChange(target.name, target.value);
  };

  handleSubmit = () => {
    if (this.props.validate()) {
      this.props.onSubmit(this.props.controls);
    }
  };

  render() {
    return (
      <SimpleModal
        title="Form Data Leasing"
        visible={this.props.state.modifyingVisible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
              <SimpleInput
                id="input_text_id"
                name="leasingId"
                label="ID"
                readOnly={R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)}
                mandatory
                errorMessage={this.props.errors.leasingId}
                value={this.props.controls.leasingId.value}
                onChange={this.handleTextChange}
              />
              <SimpleInput
                id="input_text_nama_leasing"
                name="leasingName"
                label="Nama Leasing"
                mandatory
                errorMessage={this.props.errors.leasingName}
                value={this.props.controls.leasingName.value}
                onChange={this.handleTextChange}
              />
              <SimpleInput
                  id="input_text_nama_singkatan_leasing"
                  name="abbreviatedName"
                  label="Nama Singkatan"
                  mandatory
                  errorMessage={this.props.errors.abbreviatedName}
                  value={this.props.controls.abbreviatedName.value}
                  onChange={this.handleTextChange}
              />
              <SimpleDDL
                  id="dropdown_group_leasing"
                  name="groupLeasing"
                  label="Group Leasing"
                  mandatory
                  options={this.state.groupLeasingOptions}
                  box="search"
                  errorMessage={this.props.errors.groupLeasing}
                  value={this.props.controls.groupLeasing.value}
                  onChange={(value, { name }) => this.handleTextChange({ target: { name, value } })}
              />
              <SimpleTextArea
                id="input_text_alamat"
                name="leasingAddress"
                typeInputCase="normal"
                label="Alamat"
                mandatory
                errorMessage={this.props.errors.leasingAddress}
                value={this.props.controls.leasingAddress.value}
                onChange={this.handleTextChange}
              />
              <SimpleDDL
                id="select_options_provinsi"
                box="search"
                label="Provinsi"
                name="provinceId"
                isClearable
                mandatory
                errorMessage={this.props.errors.provinceId}
                options={this.state.provinceOptions}
                value={this.props.controls.provinceId.value}
                onChange={(value, { name }) => this.handleChangeProvince(name, value)}
              />
              <SimpleDDL
                id="select_options_kota"
                box="search"
                label="Kota"
                name="kabkotId"
                isClearable
                mandatory
                errorMessage={this.props.errors.kabkotId}
                options={this.state.kotaOptions}
                readOnly={!this.props.controls.provinceId.value}
                value={this.props.controls.kabkotId.value}
                onChange={(value, { name }) => this.handleChangeKota(name, value)}
              />
              <SimpleDDL
                id="select_options_kecamatan"
                box="search"
                label="Kecamatan"
                name="kecamatanId"
                isClearable
                mandatory
                errorMessage={this.props.errors.kecamatanId}
                options={this.state.kecamatanOptions}
                readOnly={!this.props.controls.kabkotId.value}
                value={this.props.controls.kecamatanId.value}
                onChange={(value, { name }) => this.handleChangeKecamatan(name, value)}
              />
              <SimpleDDL
                id="select_options_kode_pos"
                name="zipCode"
                label="Kode Pos"
                box="search"
                isClearable
                mandatory
                errorMessage={this.props.errors.zipCode}
                readOnly={!this.props.controls.kecamatanId.value}
                options={this.state.kelurahanOptions}
                value={this.props.controls.zipCode.value}
                onChange={(value, { name }) => this.handleValueChange(name, value)}
              />
              <SimpleDDL
                id="select_options_akses_cabang"
                name="listKodeCabang"
                label="Di Akses Cabang"
                box="multiselect"
                mandatory
                errorMessage={this.props.errors.listKodeCabang}
                options={this.state.cabangOptions}
                value={this.props.controls.listKodeCabang.value}
                onChange={(value, { name }) => this.props.setValue(name, value)}
              />
              <SimpleInput
                id="input_text_api_url"
                name="leasingApiUrl"
                label="APIurl"
                value={this.props.controls.leasingApiUrl.value}
                onChange={this.handleTextChange}
              />
              <SimpleInput
                id="input_text_secret_key"
                name="leasingSecretKey"
                label="Secretkey"
                value={this.props.controls.leasingSecretKey.value}
                onChange={this.handleTextChange}
              />
              <SimpleInput
                id="input_text_token_url"
                name="leasingTokenUrl"
                label="TokenURL"
                value={this.props.controls.leasingTokenUrl.value}
                onChange={this.handleTextChange}
              />
              <FlexView hAlignContent="center">
                <SimpleButton type="button" secondary onClick={this.props.reset}>
                  Hapus
                </SimpleButton>
                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
              </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default withFormGroup(MasterLeasingModifying);
